import { VosStationBeheerDto } from "@/shared/types";

export type BeheerVosStation = {
    bemenst: boolean;
    beschikbareVossen: string[];
    stationcode: string;
    stationnaam: string;
    veilig: boolean;
};

export const BeheerVosStation = {
    fromDto: (dto: VosStationBeheerDto): BeheerVosStation => ({
        bemenst: dto.bemenst,
        beschikbareVossen: dto.beschikbareVossen,
        stationcode: dto.stationcode,
        stationnaam: dto.stationnaam,
        veilig: dto.veilig,
    }),
    sort: (a: BeheerVosStation, b: BeheerVosStation): number => {
        return a.stationcode.localeCompare(b.stationcode);
    },
};
